import { Suspense, useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router'
import { useUserData } from '../auth/api'
import Navigation from '../navigation/Navigation'
import MobileNavigation from '../navigation/MobileNavigation'
import { LeaguestarState } from '../state'
import classes from './Layout.module.css'
import { Loader, Center } from '@mantine/core'
import { ErrorBoundary } from 'react-error-boundary'
import { ErrorFallback, handleError } from './error-handler'
import Onboarding from '../onboarding/Onboarding'
import PlatformPickerGate from './PlatformPickerGate'

export default function Layout() {
  const location = useLocation()
  const { data: user } = useUserData(location.pathname)
  const [mobileNavigationOpen, setMobileNavigationOpen] = useState(false)

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo(0, 0)
    }
  }, [location.pathname])

  if (user) {
    LeaguestarState.update((state) => {
      state.user_id = user.user_id
      state.platforms = user.platforms
    })
  }

  return (
    <PlatformPickerGate platforms={user.platforms}>
      <div className={classes.container}>
        <Navigation
          user={user}
          mobileNavigationOpen={mobileNavigationOpen}
          setMobileNavigationOpen={setMobileNavigationOpen}
        />
        <MobileNavigation setMobileNavigationOpen={setMobileNavigationOpen} />
        <ErrorBoundary
          key={location.pathname}
          FallbackComponent={ErrorFallback}
          onError={handleError}
        >
          <Suspense
            fallback={
              <Center w="100%" h="100%">
                <Loader color="#0B6B7B" />
              </Center>
            }
          >
            <Outlet />
          </Suspense>
        </ErrorBoundary>
        {user.has_incomplete_required_fields && <Onboarding />}
      </div>
    </PlatformPickerGate>
  )
}
